/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useState } from "react";

import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import ListPlans from "./files/ListSubscription";
import SubscriptionDetailsPage from "./files/SubscriptionModal";
const SubscriptionPage = () => {


  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="/list"
          element={
            <>
              <ListPlans />
            </>
          }
        />
        <Route index element={<Navigate to="list" />} />
            <Route path="/details" element={<SubscriptionDetailsPage />} />
      </Route>
    </Routes>
  );
};

export default SubscriptionPage;